import axios from 'axios'
import store from '@/store'
import { getToken } from '@/axios/cookies.js'
import { BASEURL } from '@/api/index'
const service = axios.create({
    baseURL: BASEURL,
    // baseURL: 'https://wxapi.yixiang.co',
    timeout: 5000
})

service.interceptors.request.use(
    /**
     * 请求拦截器，在请求之前做配置
    */
    config => {
        config.headers['Content-Type'] = 'application/json'
        // if (store.getters.token) {
        //     config.headers['Authorization'] = 'Bearer ' + getToken()
        // }
        if (getToken()) {
            // console.log(getToken())
            config.headers['Authorization'] = 'Bearer ' + getToken()
        }
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    /**
     * 响应拦截器，在请求之前做配置
    */
    response => {
        const res = response.data

        // if (res.success === false) {
        //     return Promise.reject(new Error(res.message || 'Error'))
        // }
        return res
    },
    error => {
        console.log('err' + error.response)

        // 401无token
        if (error.response.data.status === 401) {
            store.dispatch('user/resetToken').then(() => {
                location.reload()
            })
        }
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/axios/request.js